<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <h3>{{ $t('features.create_vp') }}</h3>
            <RadioButton name="mode" label="Mode" v-model="mode" />
            <p v-if="mode === 'experiment'">{{ $t('vp.exp_brief') }}</p>
            <p v-else>{{ $t('vp.sim_brief') }}</p>

            <InputText type="text" :label="$t('common.name')" name="pname" :value="inputs.pname"
                @input="value => { handleInput({ 'key': 'pname', value: value }) }" class="col-xs-12"
                placeholder="Enter a name" />

            <InputNumber :label="$t('vp.starting_cash')" name="startingCash" :value="startingCash" @change="handleChange"
                :step="step_cash" />

            <InputNumber :label="$t('vp.monthly_add')" name="monthlyAdd" :value="monthlyAdd" @change="handleChange"
                :step="step_add" />

            <div>
                <ul v-if="errors.length">
                    <li v-for="(error, index) in errors" :key="index" class="trans-negative no-bullets">
                        {{ error }}
                    </li>
                </ul>
            </div>

            <div class="modal-footer">
                <FormButton type="primary" inputType="submit" text="Save" :click="savePortfolio" :block="true"
                    class="btn btn-lg btn-success" />
                <FormButton type="primary" inputType="submit" text="Cancel" :click="() => $emit('close')"
                    class="btn btn-lg btn-secondary" />
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FormButton from '@/components/Form/FormButton';
import InputText from '@/components/Form/InputText';
import InputNumber from '../../../components/Form/InputNumber.vue';
import DatePicker from "../../../components/Common/DatePicker.vue";
import RadioButton from "../../../components/Form/RadioButton.vue";

export default {
    name: "CreatePortfolio",
    components: {
        FormButton,
        InputText,
        InputNumber,
        DatePicker,
        RadioButton
    },
    data() {
        return {
            mode: 'experiment',
            errors: [],
            selectedDate: '',
            startingCash: 100000000,
            monthlyAdd : 0,
            inputs: {
                pname : ''
            },
            step_add: 1000000,
            step_cash: 10000000,
        };
    },
    computed: {
        ...mapGetters({
            form: "portfolio/form",   
        }),
    },
    methods: {
        ...mapActions({ 
            createPortfolio: "portfolio/createPortfolio",
        }),
        handleInput(input) {
            this.inputs[input.key] = input.value;
        },
        handleChange(obj) {
            if (obj.name === 'startingCash') {
                this.startingCash = obj.value;
            } else if (obj.name === 'monthlyAdd') {
                this.monthlyAdd = obj.value;
            }
        },
        savePortfolio() {
            const errorsList = [];
            if (!this.inputs.pname) {
                errorsList.push('Tên không được để trống');
            }
            if (this.startingCash > 2000000000 || this.startingCash < 0) {
                errorsList.push('Tiền khởi điểm không nên vượt quá 2 tỷ');
            }
            if (this.monthlyAdd > 100000000 || this.monthlyAdd < 0) {
                errorsList.push('Tiền thêm vào mỗi tháng không nên vượt quá 100 triệu');
            }
            this.errors = errorsList;
            if (this.errors.length > 0) {
                return;
            }
            const params = {
                'mode': this.mode,
                'name': this.inputs.pname,
                'startingMoney': this.startingCash,
                'monthlyAdd': this.monthlyAdd
            }
            this.createPortfolio(params);
            this.$emit("close"); // Close the modal after saving
        },
    },
};
</script>

<style scoped>
.modal-content {
    max-width: 400px;
}

.modal-footer {
    display: flex;
}
</style>